import { render, staticRenderFns } from "./repertoire.vue?vue&type=template&id=81c63216&"
import script from "./repertoire.vue?vue&type=script&lang=js&"
export * from "./repertoire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports